import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

class DonationDedicationForm extends Component {

	handleDedicationChange = (event) => {
        event.preventDefault();
        const { donationDedication } = this.props.shopStore;   
        donationDedication.set(event.target.value);
    }

    render() {
        const { donationDedication } = this.props.shopStore; 
        return (
            <span>
                <h4 className="mb-3">Dedication <small>(Optional)</small></h4>
                <div className="form-group">
                    <label>
                        Send Light To
                    </label>                
                    <input 				
                        type="text" 
                        maxLength="125"
                        className="form-control"
                        name='dedication'
                        placeholder='Enter full name' 
                        value={donationDedication.get()} 
                        onChange={this.handleDedicationChange}
                    />        
                    <span className="small text-muted">
                        <span className="font-italic">Give with intention</span> by sending light
                        to a family member, friend, or someone in need.
                    </span>                             
                </div>
            </span>
        );
    }

}

export default inject('shopStore')(observer(DonationDedicationForm));



// WEBPACK FOOTER //
// ./src/components/DonationDedicationForm.js